import { type AppViewProps } from '@/components/templates/AppView'

import { useActiveStatusSelector } from './useActiveStatusSelector.ts'
import { useMapPendingTeamStatusFilterItems } from './useMapPendingTeamStatusFilterItems.ts'
import { useTeamBaseDropdown } from './useTeamBaseDropdown.ts'
import { useTeamRegionsDropdown } from './useTeamRegionsDropdown.ts'
import { useTeamStartingLocationsDropdown } from './useTeamStartingLocationsDropdown.ts'
import { useTeamStatusDropdown } from './useTeamStatusDropdown.ts'

export const useAppNavigation = (): Pick<AppViewProps, 'navigation'> => {
  const statusSelector = useActiveStatusSelector()
  const bases = useTeamBaseDropdown()
  const startingLocations = useTeamStartingLocationsDropdown()
  const mapFilterItems = useMapPendingTeamStatusFilterItems()
  const teamStatusDropdown = useTeamStatusDropdown()
  const regionsDropdown = useTeamRegionsDropdown()
  return {
    navigation: {
      ...statusSelector,
      ...bases,
      ...startingLocations,
      ...mapFilterItems,
      ...teamStatusDropdown,
      ...regionsDropdown,
    },
  }
}
